module.exports = __webpack_public_path__ + "img/instagram.d0be3c21.png";